import React from 'react';
import { findNode } from '@udecode/plate-common';
import { getTableCellBorders } from '@udecode/plate-table';
import { translateBorderStyle } from './TableCellElement';
import { withTable } from './withTable';

export const tablePlugin = {
  options: {
    minColumnWidth: 48,
  },
  withOverrides: withTable,
  serializeHtml: ({ attributes, children, element }) => {
    const { colSizes, marginLeft } = element;
    const style = marginLeft ? { marginLeft } : {};

    return (
      <table
        {...attributes}
        className="slate-table"
        style={style}
      >
        {colSizes?.length > 0 && (
          <colgroup>
            {colSizes.map(size => (
              <col
                style={{
                  ... size > 0 && { width: `${size}px` },
                  minWidth: '48px',
                }}
              />
            ))}
            {
              /* Need to make sure that all col sizes are non zero before adding this
              last colgroup. Otherwise the 0 sized columns will actually be zero width when rendered. */
            }
            {colSizes.every(col => col > 0) && (
              <col
                style={{ width: '100%' }}
              />
            )}
          </colgroup>
        )}
        <tbody>
          {children}
        </tbody>
      </table>
    );
  },
};

export const tableRowPlugin = {
  serializeHtml: ({ attributes, children, element }) => {
    const { size } = element;
    const style = { minHeight: size };
    return (
      <tr
        {...attributes}
        style={style}
        className="slate-tr"
      >
        {children}
      </tr>
    );
  },
};

export const tableCellPlugin = {
  serializeHtml: ({ attributes, children, element, editor }) => {
    const noBorderStyle = '0px solid transparent';
    const { bgColor, colSpan } = element;

    const found = findNode(editor, { match: { id: element.id }, at: [] });
    const [, path] = found || [];
    const [rowIndex, colIndex] = path.length > 1 ? path.slice(-2) : [];
    const isFirstCell = colIndex === 0;
    const isFirstRow = rowIndex === 0;
    const borders = getTableCellBorders(element, { isFirstCell, isFirstRow });
    const {
      bottom,
      left,
      right,
      top,
    } = borders || {};

    const style = {
      backgroundColor: bgColor || 'transparent',
      borderTop: top ? translateBorderStyle(top) : noBorderStyle,
      borderRight: right ? translateBorderStyle(right) : noBorderStyle,
      borderBottom: bottom ? translateBorderStyle(bottom) : noBorderStyle,
      borderLeft: left ? translateBorderStyle(left) : noBorderStyle,
    };
    return (
      <td
        {...attributes}
        style={style}
        className="slate-td"
        colSpan={colSpan}
      >
        <div>
          {children}
        </div>
      </td>
    );
  },
};
